import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'ant-design-vue/dist/antd.css'
import Antd from 'ant-design-vue/dist/antd.js'
import VueCookies from 'vue-cookies'
import axios from 'axios'
import moment from 'moment'
import 'moment/locale/zh-cn'

// 全局配置axios
import { getUserinfo, post, patch, put, get } from '@/api/axios.js'
moment.locale('zh-cn')

axios.defaults.withCredentials = false
Vue.config.productionTip = false

Vue.use(Antd)
Vue.use(VueCookies)

Vue.prototype.$axios = axios
Vue.prototype.$getUserinfo = getUserinfo
Vue.prototype.$post = post
Vue.prototype.$get = get
// Vue.prototype.$fetch = fetch
Vue.prototype.$patch = patch
Vue.prototype.$put = put

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
